// extracted by mini-css-extract-plugin
export default {"code-view-link-button":"LinkButton-module__code-view-link-button--xvCGA"};